import { render, staticRenderFns } from "./SupportTicketBrowserInfoCell.vue?vue&type=template&id=7a851f68&"
import script from "./SupportTicketBrowserInfoCell.vue?vue&type=script&lang=js&"
export * from "./SupportTicketBrowserInfoCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports